import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";

const RegistryAccount = () => {
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    tipoConta: "Pessoa Física ou Jurídica",
    nomeCompleto: "",
    cpfCnpj: "",
    email: "",
    telefone: "",
    endereco: "",
    estado: "Selecione um Estado"
  });

  const estados = [
    "Selecione um Estado",
    "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", 
    "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", 
    "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"
  ];

  const handleInputChange = (field: string, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Formulário enviado:", formData);
  };

  return (
    <div className="space-y-6 max-w-6xl mx-auto p-6">
      {/* Cabeçalho */}
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-gray-800">Conta de Registro</h1>
        <Button 
          className="bg-[#0e7cb4] text-white"
          onClick={() => navigate('/admin/registry-account-consult')}
        >
          CONSULTAR CONTA DE REGISTRO
        </Button>
      </div>

      {/* Informações Preliminares */}
      <Card>
        <CardHeader>
          <CardTitle className="text-xl font-semibold">Criar Conta de Registro Preliminar</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex flex-col gap-1">
            <span className="text-sm">
              <strong>Código de registro preliminar:</strong> CRPBan269
            </span>
            <span className="text-sm">
              <strong>Data do Registro Preliminar:</strong> 29/09/2025
            </span>
          </div>
          <div className="pt-4">
            <Button 
              onClick={() => setShowForm(true)}
              className="bg-[#0e7cb4] text-white"
            >
              Criar Conta de Registro
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* Conteúdo do Formulário - Aparece apenas após clicar no botão */}
      {showForm && (
        <>
          {/* Banner Informativo */}
          <div className="bg-[#0e7cb4] text-white p-4 rounded-lg">
            <p className="font-bold text-lg">
              APÓS APROVAÇÃO DA ÁREA TÉCNICA E COMPLIANCE GERAR CÓDIGO DE REGISTRO DEFINITIVO COM O CADASTRO DO PROJETO
            </p>
          </div>

          {/* Texto de Instrução */}
          <div className="text-base text-gray-700">
            <p>
              Para abrir a Conta de Registro do Projeto Definitivo ver itens do Formulário de Registro do Projeto Gerador de Créditos de Carbono{" "}
              <span className="text-red-600 font-semibold cursor-pointer">mais abaixo</span>
            </p>
          </div>

          {/* Formulário de Abertura de Conta */}
          <Card>
            <CardHeader>
              <CardTitle className="text-xl font-semibold">Abertura de Conta</CardTitle>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Tipo de Conta
                    </label>
                    <select
                      value={formData.tipoConta}
                      onChange={(e) => handleInputChange('tipoConta', e.target.value)}
                      className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#0e7cb4]"
                    >
                      <option value="Pessoa Física ou Jurídica">Pessoa Física ou Jurídica</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Nome Completo / Razão Social
                    </label>
                    <Input
                      value={formData.nomeCompleto}
                      onChange={(e) => handleInputChange('nomeCompleto', e.target.value)}
                      placeholder="Nome ou Razão Social"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      CPF / CNPJ
                    </label>
                    <Input
                      value={formData.cpfCnpj}
                      onChange={(e) => handleInputChange('cpfCnpj', e.target.value)}
                      placeholder="CPF ou CNPJ"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      E-mail
                    </label>
                    <Input
                      type="email"
                      value={formData.email}
                      onChange={(e) => handleInputChange('email', e.target.value)}
                      placeholder="E-mail de contato"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Telefone
                    </label>
                    <Input
                      value={formData.telefone}
                      onChange={(e) => handleInputChange('telefone', e.target.value)}
                      placeholder="Telefone"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Endereço
                    </label>
                    <Input
                      value={formData.endereco}
                      onChange={(e) => handleInputChange('endereco', e.target.value)}
                      placeholder="Endereço completo"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Estado
                    </label>
                    <select
                      value={formData.estado}
                      onChange={(e) => handleInputChange('estado', e.target.value)}
                      className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#0e7cb4]"
                    >
                      {estados.map((estado) => (
                        <option key={estado} value={estado}>
                          {estado}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="flex justify-end pt-4">
                  <Button type="submit" className="bg-[#0e7cb4] text-white">
                    Cadastrar Conta
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </>
      )}
    </div>
  );
};

export default RegistryAccount;